/** Sendcloud sells QR and printable-label returns as separate service options; not every route publishes both. */
export const SendcloudReturnDocumentType = {
  BOTH: "both",
  QR_ONLY: "qr_only",
  LABEL_ONLY: "label_only",
} as const;

export type SendcloudReturnDocumentType =
  (typeof SendcloudReturnDocumentType)[keyof typeof SendcloudReturnDocumentType];
